import {storeToRefs} from 'pinia';
import {
	type CancelablePromise,
	type Gsoa_Counter_MarketCounter_response,
	GsoaCounterService,
} from '~/openapi';
import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';

export const useHypermarketCapacityStore = defineStore('hypermarketCapacity', () => {
	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarketInstance} = storeToRefs(hypermarketsStore);

	const capacity = ref<number | null>(null);

	const houseNumber = computed(() => Number(selectedHypermarketInstance.value?.content.gsoaId ?? 0));

	let cancelabelPromise: CancelablePromise<Gsoa_Counter_MarketCounter_response> | null = null;

	async function fetchCapacity(clearOnError = true) {
		if (!houseNumber.value) {
			return;
		}

		try {
			cancelabelPromise?.cancel();
			cancelabelPromise = cancelTimeout(() => (
				GsoaCounterService.getMarketCounter({houseNumber: houseNumber.value})
			));

			const response = await cancelabelPromise;

			const currentValue = response.counter;
			const maxValue = response.marketConfig.maxCounter;

			capacity.value = currentValue / maxValue;
		} catch (e: any) {
			if (clearOnError) {
				capacity.value = null;
			}
		}
	}

	function refreshPeriodically() {
		// Fetch fresh capacity every 10 minutes
		return useIntervalFn(
			() => fetchCapacity(false),
			10 * 60 * 1000,
		);
	}

	return {
		capacity,
		fetchCapacity,
		refreshPeriodically: createSharedComposable(refreshPeriodically),
	};
});
